import { Injectable } from "@angular/core";
import { UserSessionService } from "./user-session.service";

@Injectable({
  providedIn: 'root'
})
export class OrganizationsService {
  constructor(private user: UserSessionService) {
  }

  public async save() {
    try {
      const org = this.user.organization();
      if (!org) {
        console.error("No organization for user", this.user.sub);
        return;
      }


      const response = await fetch(`/api/platform/v1/organizations/${org.id}`, {
        method: "POST",
        body: JSON.stringify(org),
        headers: {
          "Content-Type": "application/json"
        }
      });

      const result = response.text();
      
    } catch (e) {
      console.error(e);
    }
  }
}